<template>
  <div class="content-collapse">
    <el-collapse v-model="active" accordion>
      <el-collapse-item name="1" disabled>
        <template slot="title">
          <div class="box">
            <listdesc v-for='(t,index) in dataList.slice(0,showNumber)' :key='index' :title="t[titleKey]" :content="t[contentKey]"/>
          </div>
        </template>
        <div class="box">
          <listdesc v-for='(t,index) in dataList.slice(showNumber)' :key='index' :title="t[titleKey]" :content="t[contentKey]"/>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import listdesc from './listDesc.vue';

export default{
  components:{listdesc},
  props:{
   activeName:{
     type:String,
     default:'0',
   },
   dataList:{
     type:Array,
     default:()=>[]
   },
   showNumber:{
     type:Number,
     default:10
   },
   titleKey:{
     type:String,
     default:null
   },
   contentKey:{
     type:String,
     default:null
   },
  },
  data(){
    return{
      active:0,
    }
  },
  watch:{
    activeName(val){
      this.active=val;
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-collapse{
   border:none;
   .el-collapse-item__wrap{
     border-bottom:none
   }
}
/deep/ .el-collapse-item__header{
    height: auto;
    line-height: 26px;
    background: #F7F8FA;
    border-bottom:none;
    width: 380px;
    cursor: auto;
    .el-collapse-item__arrow{
      display:none
    }
    >div{
      flex:1;
    }
}
/deep/ .el-collapse-item{
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #F7F8FA;
  padding:12px;
  box-sizing: border-box;
  .el-collapse-item__content{
    padding-bottom: 0;
  }
}
.box{
  width: 380px;
  background: #F7F8FA;
}
</style>
